// RDC horizontal plugin


(function ($) {
  'use strict';

  var RDC_HORIZONTAL_CAROUSEL_DEFAULT = {
    nav: false,
    autoWidth: true,
    center: false,
    slideBy: 1,
    startPosition: 0,
    lazyLoad:true,
    loop:false,
    items: 1,
    margin: 5,
    rewind: false,
    dots: false,
    loadLoad: false,
    responsive: {},
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    moveBy: 'item', //'item', 'set', or numbers
    showNav: 'show' // 'show', 'hover', 'none'
  };

  // Constructor
  var RdcHorizontalCarousel = function(obj, option){
    var that = this;
    this.$wrapper = $(obj);
    this.$carousel = $(obj).find('.owl-carousel');
    this.carouselOption = $.extend({}, RDC_HORIZONTAL_CAROUSEL_DEFAULT, option || {});
    var carouselOption = this.carouselOption;

    this.showHideNav = function(e){
      if (e.item.index === 0) {
        this.hideLeftNav();
      }
      else {
        this.showLeftNav();
      }
      if (e.item.index + 1 === e.item.count || e.page.size === e.item.count) {
        // If the last item is already the first active item
        // If all items are showing in one page(for autoWidth:false)
        this.hideRightNav();
      }
      else if (e.item.index + this.fullItemsInViewport() < e.item.count) {
        // When at least one is still not showing fully
        this.showRightNav();
      }
      else {
        this.hideRightNav();
      }
    };

    this.showLeftNav = function(){
      this.$wrapper.removeClass('hide-left-nav');
      this.$wrapper.find('.rdc-prev-set').removeClass('hide');
    };

    this.showRightNav = function(){
      this.$wrapper.removeClass('hide-right-nav');
      this.$wrapper.find('.rdc-next-set').removeClass('hide');
    };

    this.hideLeftNav = function(){
      this.$wrapper.addClass('hide-left-nav');
      this.$wrapper.find('.rdc-prev-set').addClass('hide');
    };

    this.hideRightNav = function(){
      this.$wrapper.addClass('hide-right-nav');
      this.$wrapper.find('.rdc-next-set').addClass('hide');
    };

    this.fullItemsInViewport = function() {
      // Return how many items are showing fully
      return Math.floor((this.$carousel.width()+ this.carouselOption.margin)/(this.$carousel.find('.owl-item.active').first().width() + this.carouselOption.margin));
    };

    this.itemsInViewport = function() {
      // Return how many items are showing (including partially)
      return Math.ceil(this.$carousel.width()/(this.$carousel.find('.owl-item.active').first().width() + this.carouselOption.margin));
    };

    this.getMoveBy = function() {
      if (this.carouselOption.moveBy === 'set') {
        if (this.fullItemsInViewport() === 0) {
          return 1;
        } else {
          return this.fullItemsInViewport();
        }
      }
      else if(Number.isInteger(this.carouselOption.moveBy) && this.carouselOption.moveBy > 0) {
        return this.carouselOption.moveBy;
      }
      return 1;
    };

    this.initNavListener = function(){
      var move_item = this.getMoveBy();
      var that = this;
      var $prevSetBtn = this.$wrapper.find('.rdc-prev-set'),
          $nextSetBtn = this.$wrapper.find('.rdc-next-set');

      $prevSetBtn.off('click').on('click',function(){
        for (var i = 0; i < move_item; i++) {
          that.$carousel.trigger('prev.owl.carousel', [150]);
        }
      });
      $nextSetBtn.off('click').on('click',function(){
        for (var i = 0; i < move_item; i++) {
          that.$carousel.trigger('next.owl.carousel', [150]);
        }
      });
    };


    // ADD initialized event
    this.$carousel.on('initialized.owl.carousel', function(e){
      // for navigation display
      if (carouselOption.showNav === 'none'){ return; }
      if (carouselOption.showNav === 'hover'){ that.$wrapper.addClass('hover-nav');}
      if (carouselOption.loop) {
        that.showLeftNav();
        that.showRightNav();
      }
      else {
        that.showHideNav(e);
        // Recalculate if showing nav button based on option.showNav and showing
        // Recalculate when page orientation changed
        that.$carousel.on('changed.owl.carousel resized.owl.carousel', function(e){
          that.showHideNav(e);
        });
      }
      that.$carousel.on('resized.owl.carousel', function(){
        that.initNavListener();
      });
      // for on-click listener
      that.initNavListener();

    });

    // Initialize Owl-Carousel
    this.$carousel.owlCarousel(carouselOption);

  };

  RdcHorizontalCarousel.VERSION ='0.1.0';

  // Carousel Plugin Definition
  function Plugin(option) {
    $(this).attr('data-rdc-carousel', 'active');
    new RdcHorizontalCarousel(this, option);
  }

  $.fn.RdcHorizontalCarousel                = Plugin;
  $.fn.RdcHorizontalCarousel.Constructor    = RdcHorizontalCarousel;
})($);



// WEBPACK FOOTER //
// ./shared_non_critical/rdc_horizontal_carousel.js